import { useEffect } from "react";
import { useLoadedData } from "../../toolympus/hooks/useLoadedData";
import { useSetAutoSuggestionsOptions } from "../../toolympus/components/primitives/AutoSuggests";

export const NationalDecisionBodySuggestionsKey = "national_decision_body";

export const useNationalDecisionBodySuggestions = (doLoad?: boolean) => {
  const setOptions = useSetAutoSuggestionsOptions();

  const suggestionsData = useLoadedData<string[]>(`/api/case-record/decision-body-suggestions?case-type=national`, [], !!doLoad);

  useEffect(() => {
    setOptions(NationalDecisionBodySuggestionsKey, suggestionsData.data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestionsData.data]);

  return {
    ...suggestionsData,
  }
}
